import "htmx.org";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js");
}

const isStandalone =
  window.navigator.standalone === true ||
  window.matchMedia("(display-mode: standalone)").matches;

const installHint = document.getElementById("install-hint");
if (installHint && !isStandalone) {
  installHint.hidden = false;
}
